import { LitElement, css, html, unsafeCSS, nothing } from 'lit';
import styles from './accordion.scss?inline';

export default class SotbitAccordion extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    static properties = {
        open: { type: Boolean, reflect: true, useDefault: true },
        collapseIconLeft: {
            type: Boolean,
            reflect: true,
            attribute: 'collapse-icon-left',
        },
        alignIconRight: {
            type: Boolean,
            reflect: true,
            attribute: 'align-icon-right',
        },
        rotateRight: { type: Boolean, reflect: true, attribute: 'rotate-right' },
    };

    constructor() {
        super();

        this.open = false;
        this.collapseIconLeft = false;
        this.rotateRight = false;
    }

    _handleHeaderClick() {
        this.open = !this.open;

        this.dispatchEvent(
            new Event('resize', {
                bubbles: true,
                cancelable: false,
                composed: true,
            })
        );
    }

    render() {
        const iconTemplate = html`
            <sotbit-icon
                pointer
                variant="secondary"
                size="m"
                icon="arrow-down"
                rotate="${this.open ? '180' : nothing}"
            ></sotbit-icon>
        `;

        return html`
            <div class="collapse">
                <div
                    part="collapse-header"
                    class="collapse-header ${this.alignIconRight ? 'align-icon-right' : ''}"
                    @click="${this._handleHeaderClick}"
                >
                    ${this.collapseIconLeft ? iconTemplate : nothing}
                    <slot name="header"></slot>
                    ${!this.collapseIconLeft ? iconTemplate : nothing}
                </div>
                <div class="collapse-body">
                    <div class="collapse-body-inner">
                        <slot></slot>
                    </div>
                </div>
            </div>
        `;
    }
}
